async function loadRemoteConfigValues() {
    // await FirebaseRemoteConfig.fetchAndActivate()
    window.remoteConfigValues = {}
    //window.remoteConfigValues.tileDecoration = (await FirebaseRemoteConfig.getString({key: "tileDecoration"})).value
    window.dispatchEvent(new Event("remoteConfigValuesUpdated"))
}
loadRemoteConfigValues()